/**
 * TrendModa - Favoriler (LocalStorage + Shopify Product API)
 * Kartlar, koleksiyon sayfalarındaki standart .ty-card ile birebir aynı olsun diye
 * client-side'da yeniden inşa edilmiyor; sunucudan sections/wishlist-card.liquid
 * üzerinden (snippets/card-product.liquid render eden) gerçek HTML olarak çekiliyor.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'tm_wishlist';
  var IS_LOGGED_IN = window.customer_logged_in || false;

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) { return []; }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  // Kalp ikonlarını ve header sayacını güncelle (sayfa yeniden render etmez)
  function syncHearts() {
    var list = getWishlist();
    var count = list.length;

    document.querySelectorAll('.ty-header__wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });

    document.querySelectorAll('[data-wishlist-handle]').forEach(function (btn) {
      var handle = btn.dataset.wishlistHandle;
      var isActive = list.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      btn.setAttribute('aria-label', isActive ? 'Favorilerden çıkar' : 'Favorilere ekle');
      var svg = btn.querySelector('svg');
      if (svg) {
        svg.style.fill = isActive ? '#f27a1a' : 'none';
        svg.style.stroke = isActive ? '#f27a1a' : 'currentColor';
      }
    });
  }

  // Tek bir ürünün gerçek .ty-card HTML'ini sunucudan çeker (card-product.liquid ile aynı render)
  function fetchCardHtml(handle) {
    return fetch('/products/' + handle + '?section_id=wishlist-card')
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.ty-card');
        return card ? card.outerHTML : '';
      })
      .catch(function () { return ''; });
  }

  // Favoriler sayfasını render et — syncHearts()'ı çağırmaz (sonsuz döngü engeli)
  async function renderWishlistPage() {
    var grid = document.getElementById('wishlist-grid');
    var empty = document.getElementById('wishlist-empty');
    var countDisplay = document.getElementById('wishlist-count-display');
    var handles = getWishlist();

    if (countDisplay) countDisplay.textContent = handles.length;

    if (handles.length === 0) {
      if (grid) grid.style.display = 'none';
      if (empty) empty.style.display = 'block';
      updateBulkBar(0);
      return;
    }

    if (!grid) return;
    grid.style.display = 'grid';
    if (empty) empty.style.display = 'none';

    // Tüm kart HTML'lerini paralel çek (sıralı bekleme yerine)
    var cardsHtml = await Promise.all(handles.map(fetchCardHtml));
    cardsHtml = cardsHtml.filter(function (html) { return html !== ''; });

    // Clear skeleton cards before inserting real content
    grid.querySelectorAll('.wishlist__skeleton-card').forEach(function (el) { el.remove(); });
    grid.innerHTML = cardsHtml.join('');

    // Trigger lazy loading for newly inserted images
    if (window.tmLazy) window.tmLazy.initImageLazyLoad();

    // Render sonrası kalp ikonlarını güncelle (renderWishlistPage çağırmadan!)
    syncHearts();
    updateBulkBar(cardsHtml.length);
  }

  function updateBulkBar(count) {
    var bar = document.getElementById('wishlist-bulk-bar');
    if (!bar) return;
    if (count === 0) {
      bar.style.display = 'none';
      return;
    }
    bar.style.display = 'flex';
    var countEl = document.getElementById('wishlist-bulk-count');
    if (countEl) countEl.textContent = count + ' ürün';
    var btn = document.getElementById('wishlist-bulk-add');
    if (btn) btn.disabled = false;
  }

  function setBulkStatus(message, isError) {
    var status = document.getElementById('wishlist-bulk-status');
    if (!status) return;
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function handleFavoriteClick(e) {
    var btn = e.target.closest('[data-wishlist-handle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.dataset.wishlistHandle;
    var list = getWishlist();
    var idx = list.indexOf(handle);

    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    syncHearts();

    // Favoriler sayfasındaysa listeyi yenile
    var isWishlistPage = window.location.pathname.indexOf('wishlist') !== -1 ||
                         window.location.pathname.indexOf('favori') !== -1;
    if (isWishlistPage) renderWishlistPage();
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.ty-header__cart-count, #cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  function notifyCartUpdated(source, data) {
    var cartDrawer = document.querySelector('cart-drawer') || document.querySelector('#cart-drawer');
    if (cartDrawer) {
      if (data.sections && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      } else if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    }
    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: source, cartData: data });
    }
  }

  function addAllToCart() {
    var btn = document.getElementById('wishlist-bulk-add');
    if (!btn || btn.dataset.busy === 'true') return;

    var grid = document.getElementById('wishlist-grid');
    if (!grid) return;

    var atcButtons = Array.from(grid.querySelectorAll('.ty-card__atc[data-variant-id]'));
    var skippedSoldout = grid.querySelectorAll('.ty-card__atc--soldout').length;

    if (atcButtons.length === 0) {
      setBulkStatus('Sepete eklenebilecek stokta ürün bulunamadı.', true);
      return;
    }

    var invalidButtons = atcButtons.filter(function (button) {
      var variantId = Number(button.dataset.variantId);
      return button.dataset.requiresSize === 'true' || !Number.isInteger(variantId) || variantId <= 0;
    });

    if (invalidButtons.length > 0) {
      setBulkStatus('Devam etmek için ' + invalidButtons.length + ' üründe beden seçin.', true);
      var firstCard = invalidButtons[0].closest('.ty-card');
      var sizes = firstCard && firstCard.querySelector('[data-card-sizes]');
      if (sizes) {
        sizes.classList.add('ty-card__sizes--attention');
        sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var firstSize = sizes.querySelector('.ty-card__size:not(.ty-card__size--disabled)');
        if (firstSize) firstSize.focus({ preventScroll: true });
      }
      return;
    }

    setBulkStatus('', false);

    btn.dataset.busy = 'true';
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Ekleniyor…';

    var items = atcButtons.map(function (b) {
      return { id: Number(b.dataset.variantId), quantity: 1 };
    });

    var cartDrawer = document.querySelector('cart-drawer') || document.querySelector('#cart-drawer');
    var sectionsParam = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sectionsParam = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
    }

    var payload = { items: items };
    if (sectionsParam.length > 0) {
      payload.sections = sectionsParam;
      payload.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Ürünler eklenemedi');
          return data;
        });
      })
      .then(function (data) {
        if (data.status) {
          throw new Error(data.description || 'Ürünler eklenemedi');
        }
        updateCartCount();
        var summary = items.length + ' ürün sepete eklendi';
        if (skippedSoldout > 0) summary += ' (' + skippedSoldout + ' ürün stokta yok, atlandı)';
        btn.textContent = summary;
        setBulkStatus(summary, false);
        notifyCartUpdated('wishlist-bulk-add', data);
      })
      .catch(function (err) {
        console.error('[wishlist-bulk-add]', err);
        btn.textContent = 'Hata — Tekrar Dene';
        setBulkStatus(err.message || 'Ürünler eklenemedi. Lütfen tekrar deneyin.', true);
      })
      .finally(function () {
        setTimeout(function () {
          btn.dataset.busy = 'false';
          btn.disabled = false;
          btn.textContent = originalText;
        }, 2500);
      });
  }

  function init() {
    syncHearts();

    // Favoriler sayfasındaysa içeriği yükle
    var isWishlistPage = window.location.pathname.indexOf('wishlist') !== -1 ||
                         window.location.pathname.indexOf('favori') !== -1;
    if (isWishlistPage) renderWishlistPage();

    document.addEventListener('click', handleFavoriteClick);

    var bulkAddBtn = document.getElementById('wishlist-bulk-add');
    if (bulkAddBtn) bulkAddBtn.addEventListener('click', addAllToCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for manual trigger
  window.tmWishlist = { syncHearts: syncHearts };
})();
